/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Entitybuildsdescription2Inputs */

const id_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket biner`)
};

const ms_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle binari`)
};

const da_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binære bundter`)
};

const de_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binäre Pakete`)
};

const en_us2_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binary bundles`)
};

const es_es2_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paquetes de binarios`)
};

const es_mx2_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paquetes de binarios`)
};

const fil_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga bundle ng binary`)
};

const fr_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paquets binaires`)
};

const it_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacchetti binari`)
};

const hu_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bináris csomagok`)
};

const nl_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaire bundels`)
};

const no_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binære bunter`)
};

const pl_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakiety binarne`)
};

const pt_br2_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacotes binários`)
};

const pt_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacotes binários`)
};

const ro_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pachete binare`)
};

const fi_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaaripaketit`)
};

const sv_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binära paket`)
};

const vi_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gói nhị phân`)
};

const tr_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İkili paketler`)
};

const cs_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binární balíčky`)
};

const bg_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бинарни пакети`)
};

const ru_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записи о бинарных пакетах`)
};

const uk_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бінарні пакунки`)
};

const ar_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حزم البرامج الثنائية`)
};

const hi_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाइनरी बंडल`)
};

const th_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันเดิลไบนารี`)
};

const ja_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バイナリバンドル`)
};

const zh_cn2_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二进制捆绑包`)
};

const zh_hant1_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二進位制捆綁包`)
};

const ko_sandboxes_entitybuildsdescription2 = /** @type {(inputs: Sandboxes_Entitybuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`바이너리 번들`)
};

/**
* | output |
* | --- |
* | "Binary bundles" |
*
* @param {Sandboxes_Entitybuildsdescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_entitybuildsdescription2 = /** @type {((inputs?: Sandboxes_Entitybuildsdescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Entitybuildsdescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "ms") return ms_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "da") return da_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "de") return de_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "fil") return fil_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "fr") return fr_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "it") return it_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "hu") return hu_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "nl") return nl_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "no") return no_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "pl") return pl_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "pt") return pt_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "ro") return ro_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "fi") return fi_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "sv") return sv_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "vi") return vi_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "tr") return tr_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "cs") return cs_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "bg") return bg_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "ru") return ru_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "uk") return uk_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "ar") return ar_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "hi") return hi_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "th") return th_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "ja") return ja_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_entitybuildsdescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_entitybuildsdescription2(inputs)
	return ko_sandboxes_entitybuildsdescription2(inputs)
});
export { sandboxes_entitybuildsdescription2 as "sandboxes.entityBuildsDescription" }